import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';
import getInterleavedSearchExperimentStore from '../store/store';

export function getIsCloudCacheCrawlingComplete(mailboxInfo: MailboxInfo): boolean | undefined {
    return getInterleavedSearchExperimentStore().isCloudCacheCrawlingCompleteByAccountKey.get(
        getAccountKeyForMailboxInfo(mailboxInfo)
    );
}
